<template>
  <div class="insurance-intermediary-page">
    <InsuranceIntermediary />
  </div>
</template>

<script>
import { InsuranceIntermediary } from '@/features/promo';

export default {
  components: { InsuranceIntermediary },
};
</script>

<style lang="scss" scoped>
.insurance-intermediary-page {
  overflow: hidden;
}
</style>
